import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import FormEdit from '../../../../components/auth/partido/listar/form_edit'
import Head from '../../../../components/head'


function EditarPartidoScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Liberação de Recurso" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarPartidoScreen;